import { ReactNode } from 'react';
import './Content.scss';

type ContentType = 'primary' | 'inverse';

const Content = ({
    heading,
    children,
    variation,
    sectionId
} : {
    heading?: string;
    children: ReactNode;
    variation?: ContentType,
    sectionId?: string;
}) => {
    return (
        <section className={`content ${variation ?? 'primary'}`} id={sectionId}>
            <div className='container'>
                {heading &&
                <h2 className='page-title'>
                    {heading}
                </h2>}
                {children}
            </div>
        </section>
    )
}

export default Content;